import React from "react";

import { Row, Col, Card, CardBody, CardTitle } from "reactstrap";

const WelcomeComp = () => {
  return (
    <React.Fragment>
      
          <Row className="h-100">
            <Col xs="12">
              <Card className="mini-stats-wid m-1" style={{backgroundColor: "#f3f3f3"}}>
                <CardBody>
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <p className="text-muted fw-medium">New Visitors</p>
                      <h4 className="mb-0">528+</h4>
                    </div>
                    <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                      <span className="avatar-title rounded-circle bg-primary">
                        <i className={"bx bx-user-check font-size-24"}></i>
                      </span>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col xs="12">
              <Card className="mini-stats-wid m-1" style={{backgroundColor: "#f3f3f3"}}>
                <CardBody>
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <p className="text-muted fw-medium">Inventory Lead</p>
                      <h4 className="mb-0">528+</h4>
                    </div>
                    <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                      <span className="avatar-title rounded-circle bg-primary">
                        <i className={"mdi mdi-eye-outline font-size-24"}></i>
                      </span>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col xs="12">
              <Card className="mini-stats-wid m-1" style={{backgroundColor: "#f3f3f3"}}>
                <CardBody>
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <p className="text-muted fw-medium">Page Views</p>
                      <h4 className="mb-0">528+</h4>
                    </div>
                    <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                      <span className="avatar-title rounded-circle bg-primary">
                        <i className={"bx bx-compass font-size-24"}></i>
                      </span>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        
    </React.Fragment>
  );
};
export default WelcomeComp;
